import { Component } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { routes } from '../../app-routing.module';
import { Title } from '@angular/platform-browser';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../environments/environment';
import { AppConfigService } from '../../app-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe('(max-width: 960px)')
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  routes = routes;
  logged = false;
  username = '';
  logoPath = environment.logoPath;
  accentColor = '#ff5a00'; // Default color
  accentLightColor = '#ff5a0033'; // Default light color

  constructor(
    public router: Router,
    public titleService: Title,
    private breakpointObserver: BreakpointObserver,
    private readonly keycloak: KeycloakService,
    private appConfigService: AppConfigService) {
  }
  async ngOnInit(): Promise<void> {
    this.logged = await this.keycloak.isLoggedIn();
    this.username = this.logged ? this.resolveUsername() : '';
    
    // Load accent colors from config
    const config = this.appConfigService.getConfig();
    this.accentColor = config?.accentColor || this.accentColor;
    this.accentLightColor = config?.accentLight || this.accentLightColor;

    this.applyAccentColors(this.accentColor, this.accentLightColor);
  }

  private applyAccentColors(color: string, lightColor: string): void {
    document.documentElement.style.setProperty('--app-accent-color', color);
    document.documentElement.style.setProperty('--app-accent-light', lightColor);
  }

  private resolveUsername(): string {
    const keycloakInstance = this.keycloak.getKeycloakInstance();
    const parsedToken = keycloakInstance?.tokenParsed as any;

    return (
      parsedToken?.preferred_username ||
      parsedToken?.name ||
      parsedToken?.given_name ||
      parsedToken?.email ||
      this.keycloak.getUsername?.() ||
      ''
    );
  }

  getSectionIcon(): string {
    const url = this.router.url;
    if (url.startsWith('/introduction')) return 'dashboard';
    if (url.startsWith('/contracts')) return 'description';
    if (url.startsWith('/transfer-history')) return 'history';
    if (url.startsWith('/catalog-browser')) return 'menu_book';
    if (url.startsWith('/data-offers')) return 'upload';
    if (url.startsWith('/policies')) return 'policy';
    if (url.startsWith('/my-assets')) return 'inbox';
    return 'dashboard';
  }
}
